import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'

const GrowthWheelWorks = () => {
  return (
    <div className="card gw-works-card mt-3">
      <div className="card-body gw-works-body">
        <h6 className="gw-works-title">How the Growth Wheel works</h6>
        <ul className="gw-works-list">
          <li className="gw-works-item">
            <FontAwesomeIcon icon={faCircleCheck} className="gw-works-icon" />
            <span className="gw-works-text">
              Complete self-assessments at your own pace
            </span>
          </li>
          <li className="gw-works-item">
            <FontAwesomeIcon icon={faCircleCheck} className="gw-works-icon" />
            <span className="gw-works-text">
              Your Admin will add guided scores and feedback
            </span>
          </li>
          <li className="gw-works-item">
            <FontAwesomeIcon icon={faCircleCheck} className="gw-works-icon" />
            <span className="gw-works-text">
              Use this as a foundation for meaningful growth conversations
            </span>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default GrowthWheelWorks
